export default __webpack_public_path__ + "static/media/sellCategoryImage.c4d28ee7.jpg";